import React, { useEffect, useState, useRef } from "react";

import IsLogin from "../../utilities/functions/isLogin";
import { useLocation, useNavigate, Link } from "react-router-dom";
import apiConfig from "../../utilities/apiConfig.json";
import serverConfig from "../../utilities/serverConfig.json";
import axios from "axios";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import scrollToTop from "../../utilities/functions/ScrollToTop"; // Adjust the path to where your function is located
import doctorIcon from "./../../assets/images/icons/doctor.svg";
import DoctorCard from "./doctorCard";
import isWhitespaceString from "../../utilities/functions/isWhiteSpaceString";
import { useSelector } from "react-redux";
import haveAccess from "../../utilities/functions/haveAccess";
import AddIcon from "./../../assets/images/icons/Google SVGs/add.svg";
import RemoveIcon from "./../../assets/images/icons/Google SVGs/remove.svg";
import { ReactComponent as ArrowRightAltIcon } from "./../../assets/images/icons/Google SVGs/arrow_right_alt.svg";

const DoctorStore = () => {
  const [logIn, setLogIn] = useState();
  const navigate = useNavigate();
  const { token, roles } = useSelector((state) => state.user);
  const tokenLocal = localStorage.getItem("token");

  const headers = {
    Authorization: "Bearer " + (token ? token : tokenLocal),
  };

  const [loading, setLoading] = useState(false);
  const [loadingStore, setLoadingStore] = useState(false);

  const [clearData, setClearData] = useState(false);
  const [editing, setEditing] = useState(false);
  const [userID, setUserID] = useState();

  const [doctors, setDoctors] = useState();

  const { search } = useLocation();
  const queryParams = new URLSearchParams(search);
  const dr = queryParams.get("dr") ? queryParams.get("dr") : null; // Getting the value of 'dr' from the query string

  // #region pages variables
  const [searchValue, setSearchValue] = useState("");
  const [paginationElem, setPaginationElem] = useState();
  const [currentPage, setCurrentPage] = useState(1);
  const [pageCount, setPageCount] = useState(0);
  const [perPage, setPerPage] = useState(24);
  // #endregion

  // #region city province
  const [cities, setCities] = useState();
  const [provinces, setProvinces] = useState();
  const [selectedCity, setSelectedCity] = useState("");
  const [selectedProvince, setSelectedProvince] = useState("");
  // #endregion

  // #region specialty & education variables
  const [addtoList, setAddtolist] = useState(false);
  const [specialties, setSpecialties] = useState();
  const [educations, setEducations] = useState();
  const [specialtySearch, setSpecialtySearch] = useState("");
  const [educationSearch, setEducationSearch] = useState("");

  const [selectedSpecialtyId, setSelectedSpecialtyId] = useState(null);
  const [selectedSpecialtyTitle, setSelectedSpecialtyTitle] = useState(null);
  const [selectedEducationId, setSelectedEducationId] = useState(null);
  const [selectedEducationTitle, setSelectedEducationTitle] = useState(null);
  const [listSpecEdu, setListSpecEdu] = useState([]);
  // #endregion

  const [preview, setPreview] = useState();
  const [doctorPhoto, setDoctorPhoto] = useState();

  const [doctorTitle, setDoctorTitle] = useState("");
  const [doctorFirstName, setDoctorFirstName] = useState("");
  const [doctorLastName, setDoctorLastName] = useState("");
  const [doctorPhoneNumber, setDoctorPhoneNumber] = useState("");
  const [nationalId, setNationalId] = useState("");
  const [organizationID, setOrganizationId] = useState("");

  const isInitialRender = useRef(true);
  const isInitialRender2 = useRef(true);

  const doctorPhotoChangeHandler = (e) => {
    setDoctorPhoto(e);
  };

  const doctorStoreAPI = () => {
    setLoadingStore(true);
    // create a new FormData object and append the file to it
    const formData = new FormData();
    doctorTitle != "null" &&
      doctorTitle != null &&
      formData.append("title", doctorTitle);
    formData.append("first_name", doctorFirstName);
    formData.append("last_name", doctorLastName);
    formData.append("mobile", doctorPhoneNumber);
    formData.append("national_id", nationalId);
    formData.append("organ_id", organizationID);
    formData.append("province_id", selectedProvince);
    formData.append("city_id", selectedCity);
    if (doctorPhoto) {
      formData.append("file", doctorPhoto.target.files[0]);
    }

    const transformedArray = listSpecEdu.map((item) => ({
      specialty_id: item.specialty_id,
      education_id: item.education_id,
    }));

    formData.append("education_specialties", JSON.stringify(transformedArray));

    // make a POST request to the File Upload API with the FormData object and Rapid API headers
    axios
      .post(
        serverConfig.server.url + apiConfig.api.storeAPIs.storeDoctor,
        formData,
        {
          headers,
        }
      )
      .then((response) => {
        setLoadingStore(false);
        if (response.data.status === "success") {
          toast.success(response.data.message);
          setClearData(true);
          getDoctorsAPI();
          navigate("/doctor-store");
        } else {
          if (typeof response.data.errors === typeof "String") {
            toast.error(response.data.errors);
          } else {
            response.data.errors.forEach((element) => {
              toast.error(element);
            });
          }
        }
      })
      .catch((error) => {
        setLoadingStore(false);
        toast.error("Error making API call:", error);
      });
  };

  const doctorUpdateAPI = () => {
    setLoadingStore(true);
    // create a new FormData object and append the file to it
    const formData = new FormData();
    formData.append("user_id", userID);
    formData.append("title", doctorTitle);
    formData.append("first_name", doctorFirstName);
    formData.append("last_name", doctorLastName);
    formData.append("mobile", doctorPhoneNumber);
    formData.append("national_id", nationalId);
    formData.append("organ_id", organizationID);
    formData.append("province_id", selectedProvince);
    formData.append("city_id", selectedCity);

    if (doctorPhoto) {
      formData.append("file", doctorPhoto.target.files[0]);
    }

    const transformedArray = listSpecEdu.map((item) => ({
      specialty_id: item.specialty_id,
      education_id: item.education_id,
    }));

    formData.append("education_specialties", JSON.stringify(transformedArray));

    // make a POST request to the File Upload API with the FormData object and Rapid API headers
    axios
      .post(
        serverConfig.server.url + apiConfig.api.updateAPIs.updateDoctor,
        formData,
        {
          headers,
        }
      )
      .then((response) => {
        setLoadingStore(false);
        if (response.data.status === "success") {
          toast.success(response.data.message);
          setEditing(false);
          setClearData(true);
          getDoctorsAPI();
          navigate("/doctor-store");
        } else {
          if (typeof response.data.errors === typeof "String") {
            toast.error(response.data.errors);
          } else {
            response.data.errors.forEach((element) => {
              toast.error(element);
            });
          }
        }
      })
      .catch((error) => {
        setLoadingStore(false);
        toast.error("Error making API call:", error);
      });
  };

  const specialtiesAPI = () => {
    setLoading(true);
    axios
      .post(serverConfig.server.url + apiConfig.api.publicAPIs.getSpecialties)
      .then((response) => {
        setLoading(false);
        if (response.data.status === "success") {
          setSpecialties(response.data.data.specialties);
        } else {
          if (typeof response.data.errors === typeof "String") {
            toast.error(response.data.errors);
          } else {
            response.data.errors.forEach((element) => {
              toast.error(element);
            });
          }
        }
      })
      .catch((error) => {
        setLoading(false);
        toast.error("Error making API call:", error);
      });
  };

  const educationsAPI = () => {
    setLoading(true);
    axios
      .get(serverConfig.server.url + apiConfig.api.publicAPIs.getEducations)
      .then((response) => {
        setLoading(false);
        if (response.data.status === "success") {
          setEducations(response.data.data.educations);
        } else {
          if (typeof response.data.errors === typeof "String") {
            toast.error(response.data.errors);
          } else {
            response.data.errors.forEach((element) => {
              toast.error(element);
            });
          }
        }
      })
      .catch((error) => {
        setLoading(false);
        toast.error("Error making API call:", error);
      });
  };

  const getDoctorsAPI = () => {
    setLoading(true);
    axios
      .post(
        serverConfig.server.url +
        apiConfig.api.getAPIs.getDoctors +
        "?page=" +
        currentPage,
        {
          per_page: perPage,
          ...(isWhitespaceString(searchValue) && { search_value: searchValue }),
          pagination: true,
        },
        { headers }
      )
      .then((response) => {
        setLoading(false);
        if (response.data.status === "success") {
          setDoctors(response.data.data.doctors);

          // pagination
          setPaginationElem();
          setPageCount(response.data.data.page_count);
          for (let i = 1; i <= response.data.data.page_count; i++) {
            setPaginationElem((prevPaginationElem) => (
              <>
                {prevPaginationElem}
                <li
                  className={"page-item" + (currentPage == i ? " active" : "")}
                >
                  <a
                    className="page-link"
                    href="#"
                    onClick={() => {
                      setCurrentPage(i);
                      scrollToTop();
                    }}
                  >
                    {i}
                  </a>
                </li>
              </>
            ));
          }
        } else {
          if (typeof response.data.errors === typeof "String") {
            toast.error(response.data.errors);
          } else {
            response.data.errors.forEach((element) => {
              toast.error(element);
            });
          }
        }
      })
      .catch((error) => {
        setLoading(false);
        toast.error("Error making API call:", error);
      });
  };

  const getDoctorProfileAPI = () => {
    setLoadingStore(true);
    axios
      .post(
        serverConfig.server.url + apiConfig.api.getAPIs.getUserProfile,
        {
          user_id: userID,
        },
        { headers }
      )
      .then((response) => {
        setLoadingStore(false);
        if (response.data.status === "success") {
          response.data.data.title != null
            ? setDoctorTitle(response.data.data.title)
            : setDoctorTitle("");
          setDoctorFirstName(response.data.data.first_name);
          setDoctorLastName(response.data.data.last_name);
          setDoctorPhoneNumber(response.data.data.mobile);
          setSelectedProvince(response.data.data.province_id);
          setSelectedCity(response.data.data.city_id);
          setDoctorPhoneNumber(response.data.data.mobile);
          response.data.data.national_id &&
            setNationalId(response.data.data.national_id);
          setOrganizationId(response.data.data.organ_id);
          if (response.data.data.file && response.data.data.file.length > 0)
            setPreview(response.data.data.file);
          else setPreview("");
          response.data.data.doctor_specialties &&
            setListSpecEdu(
              addTitlesToDoctors(
                response.data.data.doctor_specialties,
                specialties,
                educations
              )
            );
          const transformedArray = listSpecEdu.map((item) => ({
            specialty_id: item.specialty_id,
            education_id: item.education_id,
          }));
        } else {
          if (typeof response.data.errors === typeof "String") {
            toast.error(response.data.errors);
          } else {
            response.data.errors.forEach((element) => {
              toast.error(element);
            });
          }
        }
      })
      .catch((error) => {
        setLoadingStore(false);
        toast.error("Error making API call:", error);
      });
  };

  const stateAPI = () => {
    setLoading(true);
    axios
      .get(
        serverConfig.server.url + apiConfig.api.publicAPIs.getProvincesAndCities
      )
      .then((response) => {
        setLoading(false);
        if (response.data.status === "success") {
          setProvinces(response.data.data.provinces);
          setCities(response.data.data.cities);
        } else {
          if (typeof response.data.errors === typeof "String") {
            toast.error(response.data.errors);
          } else {
            response.data.errors.forEach((element) => {
              toast.error(element);
            });
          }
        }
      })
      .catch((error) => {
        setLoading(false);
        console.error("Error making API call:", error);
      });
  };

  function addTitlesToDoctors(doctorSpecialties, specialties, educations) {
    doctorSpecialties.forEach((doctor) => {
      const specialty = specialties.find(
        (spec) => spec.id == doctor.specialty_id
      );
      const education = educations.find((edu) => edu.id == doctor.education_id);

      doctor.specialty_title = specialty.title;
      doctor.education_title = education.title;
    });

    return doctorSpecialties;
  }

  // Function to map specialty ID to title
  // const mapSpecialtyIdToTitle = (specialtyId) => {
  //   const specialty = specialties.find(
  //     (specialty) => specialty.id == specialtyId
  //   );
  //   return specialty ? specialty.title : "";
  // };

  // // Function to map education ID to title
  // const mapEducationIdToTitle = (educationId) => {
  //   const education = educations.find(
  //     (education) => education.id == educationId
  //   );
  //   return education ? education.title : "";
  // };

  useEffect(() => {
    if (addtoList) {
      setListSpecEdu((prev) => [
        ...prev,
        {
          specialty_id: selectedSpecialtyId,
          education_id: selectedEducationId,
          specialty_title: selectedSpecialtyTitle,
          education_title: selectedEducationTitle,
        },
      ]);
      setSelectedEducationId(null);
      setSelectedSpecialtyId(null);
      setSelectedEducationTitle(null);
      setSelectedSpecialtyTitle(null);
      setAddtolist(false);
    }
  }, [addtoList]);

  useEffect(() => {
    if (clearData) {
      setPreview();
      setDoctorPhoto();
      setDoctorTitle("");
      setDoctorFirstName("");
      setDoctorLastName("");
      setDoctorPhoneNumber("");
      setNationalId("");
      setOrganizationId("");
      setListSpecEdu([]);
      setSelectedProvince("");
      setSelectedCity("");
      // setUserID("");
      setClearData(false);
    }
  }, [clearData]);

  // doctor photo
  useEffect(() => {
    if (doctorPhoto) {
      // create the preview
      const objectUrl = URL.createObjectURL(doctorPhoto.target.files[0]);
      setPreview(objectUrl);

      // free memory when ever this component is unmounted
      return () => URL.revokeObjectURL(objectUrl);
    }
  }, [doctorPhoto]);

  // is login
  useEffect(() => {
    let res = IsLogin();
    if (res) {
      specialtiesAPI();
      educationsAPI();
      getDoctorsAPI();
      stateAPI();
    } else {
      localStorage.setItem(
        "callBackURL",
        window.location.pathname + window.location.search
      );
      navigate("/login");
    }
  }, []);

  // pagination
  useEffect(() => {
    if (!isInitialRender2.current) {
      getDoctorsAPI();
    } else {
      isInitialRender2.current = false;
    }
  }, [currentPage]);

  // pagination
  useEffect(() => {
    if (!isInitialRender.current) {
      setCurrentPage(1);
      getDoctorsAPI();
    } else {
      isInitialRender.current = false;
    }
  }, [searchValue, perPage]);

  useEffect(() => {
    if (editing && specialties && educations) {
      getDoctorProfileAPI();
    }
  }, [editing, userID, specialties, educations]);

  useEffect(() => {
    const checkLoginStatus = async () => {
      const loggedIn = await IsLogin();
      setLogIn(loggedIn !== false);
      if (loggedIn === false || loggedIn === "error api") {
        // localStorage.clear();
        localStorage.getItem("FullName") && localStorage.removeItem("FullName");
        localStorage.getItem("mobile") && localStorage.removeItem("mobile");
        localStorage.getItem("token") && localStorage.removeItem("token");
        localStorage.setItem(
          "callBackURL",
          window.location.pathname + window.location.search
        );
        navigate("/login");
      }
    };

    checkLoginStatus();
  }, []);

  useEffect(() => {
    if (dr) {
      setEditing(true);
      setUserID(dr);
    }
  }, [dr]);

  return (
    <div className="d-flex row pt-3">
      <div>
        {/* Cards */}

        {logIn &&
          (haveAccess(roles, "doctor_add") ||
            haveAccess(roles, "doctor_edit")) && (
            <div className="card card-box-shadow border-0 mb-3">
              <div className="card-body d-flex row">
                <h5>ثبت پزشک</h5>
                <div className="d-flex flex-row">
                  {/* File Preview */}
                  {preview ? (
                    <div className="d-flex col my-2 me-3 col-auto">
                      <img
                        className="doctor-image-box col col-auto object-fit-cover"
                        src={preview}
                      />
                    </div>
                  ) : (
                    <div className="d-flex col my-2 me-3 col-auto">
                      <img
                        className="doctor-image-box col col-auto object-fit-cover rounded-pill p-2 background-bootstrap-gray-200"
                        src={doctorIcon}
                      />
                    </div>
                  )}

                  {/* File Uploader */}
                  <div className="d-flex col my-2 flex-column ">
                    <input
                      // className={`form-control ${preview ? "d-none" : ""}`}
                      className="form-control w-100"
                      type="file"
                      id="formFile"
                      onChange={(e) => {
                        doctorPhotoChangeHandler(e);
                      }}
                    />
                    <span className="text-secondary fs-14 fw-normal">
                      حداکثر حجم مجاز عکس 1 مگابایت میباشد
                    </span>
                  </div>
                </div>

                <div className="d-flex col my-2 col-6 col-lg-3">
                  <input
                    className="form-control"
                    type="text"
                    placeholder="عنوان پزشک"
                    value={doctorTitle}
                    onChange={(e) => {
                      setDoctorTitle(e.target.value);
                    }}
                  />
                </div>
                <div className="d-flex col my-2 col-6 col-lg-3">
                  <input
                    className="form-control"
                    type="text"
                    placeholder="نام پزشک"
                    value={doctorFirstName}
                    onChange={(e) => {
                      setDoctorFirstName(e.target.value);
                    }}
                  />
                </div>
                <div className="d-flex col my-2 col-12 col-lg-6">
                  <input
                    className="form-control"
                    type="text"
                    placeholder="نام خانوادگی پزشک"
                    value={doctorLastName}
                    onChange={(e) => {
                      setDoctorLastName(e.target.value);
                    }}
                  />
                </div>
                {/* Province Dropdown */}
                <div className="d-flex col my-2 col-12 col-lg-6">
                  <select
                    className="form-select"
                    aria-label="استان"
                    value={selectedProvince ? selectedProvince : ""}
                    onChange={(e) => {
                      setSelectedProvince(e.target.value);
                    }}
                  >
                    <option value="" disabled>
                      استان را انتخاب کنید
                    </option>
                    {provinces &&
                      provinces.map((e) => (
                        <option key={e.id} value={e.id}>
                          {e.name}
                        </option>
                      ))}
                  </select>
                </div>

                {/* City Dropdown */}
                <div className="d-flex col my-2 col-12 col-lg-6">
                  <select
                    className="form-select"
                    aria-label="شهر"
                    value={selectedCity && selectedProvince ? selectedCity : ""}
                    onChange={(e) => {
                      setSelectedCity(e.target.value);
                    }}
                  >
                    <option value="" disabled>
                      شهر را انتخاب کنید
                    </option>

                    {cities &&
                      selectedProvince &&
                      cities
                        .filter((e) => e.province_id == selectedProvince)
                        .map((e) => (
                          <option key={e.id} value={e.id}>
                            {e.name}
                          </option>
                        ))}
                  </select>
                </div>
                <div className="d-flex col my-2 col-12 col-lg-6">
                  <input
                    className="form-control "
                    type="text"
                    placeholder="کد نظام پزشکی"
                    value={organizationID}
                    onChange={(e) => {
                      setOrganizationId(e.target.value);
                    }}
                  />
                </div>
                <div className="d-flex col my-2 col-12 col-lg-6">
                  <input
                    className="form-control h-fit"
                    type="text"
                    placeholder="کد ملی پزشک"
                    value={nationalId}
                    onChange={(e) => {
                      setNationalId(e.target.value);
                    }}
                  />
                </div>
                <div className="d-flex col my-2 col-12 col-lg-6">
                  <div className="d-flex row w-100 m-0">
                    <div
                      className="btn btn-outline-active d-flex align-items-center"
                      data-bs-toggle="modal"
                      data-bs-target="#specialty-modal"
                    >
                      افزودن تخصص / میزان تحصیلات
                      <img
                        src={AddIcon}
                        className="ms-auto"
                        width={20}
                        alt=""
                      />
                    </div>
                    <div className="d-flex row mx-0 col-12 px-0">
                      {listSpecEdu &&
                        listSpecEdu.map((SpectEdu) => (
                          <span
                            key={SpectEdu.specialty_id}
                            className="d-flex btn border-1 border-iso-blue-300 color-iso-blue-300 rounded-pill p-1 ps-3 pe-2 py-1 me-1 mt-2 col col-auto bg-iso-blue-100 fs-12 align-items-center"
                            onClick={() => {
                              const updatedListSpecEdu = listSpecEdu.filter(
                                (item) =>
                                  item.specialty_id !== SpectEdu.specialty_id
                              );
                              setListSpecEdu(updatedListSpecEdu);
                            }}
                          >
                            {SpectEdu.education_title}{" "}
                            {SpectEdu.specialty_title}
                            <img
                              src={RemoveIcon}
                              className="ms-2 me-0"
                              width={16}
                              alt=""
                            />
                          </span>
                        ))}
                    </div>
                  </div>
                </div>

                <div className="d-flex col my-2 col-12 col-lg-6">
                  <input
                    className="form-control h-fit"
                    type="text"
                    placeholder="شماره همراه پزشک"
                    value={doctorPhoneNumber}
                    onChange={(e) => {
                      setDoctorPhoneNumber(e.target.value);
                    }}
                  />
                </div>

                <div className="d-flex col my-2 col-12">
                  {editing ? (
                    <>
                      <div className="d-flex col-6">
                        <button
                          type="button"
                          disabled={loadingStore}
                          className="btn btn-primary w-100 me-1"
                          onClick={doctorUpdateAPI}
                        >
                          ویرایش پزشک
                          {loadingStore && (
                            <span
                              className="spinner-border spinner-border-sm ms-1"
                              role="status"
                              aria-hidden="true"
                            />
                          )}
                        </button>
                      </div>
                      <div className="d-flex col-6">
                        <button
                          type="button"
                          disabled={loadingStore}
                          className="btn btn-outline-primary w-100 ms-1"
                          onClick={() => {
                            setClearData(true);
                            setEditing(false);
                            navigate("/doctor-store");
                          }}
                        >
                          انصراف
                        </button>
                      </div>
                    </>
                  ) : (
                    <button
                      type="button"
                      className="btn btn-primary w-100"
                      onClick={doctorStoreAPI}
                    >
                      ثبت پزشک
                      {loading && (
                        <span
                          className="spinner-border spinner-border-sm ms-1"
                          role="status"
                          aria-hidden="true"
                        />
                      )}
                    </button>
                  )}
                </div>
              </div>
            </div>
          )}

        <div>
          <div className="card card-box-shadow border-0 mb-3">
            <div className="card-body d-flex flex-column">
              <div className="d-flex align-items-center mb-2">
                <p className="col fs-18 fw-medium w-auto m-0">لیست پزشکان</p>
                <div className="d-flex w-auto">
                  <input
                    className="form-control ms-1 col"
                    type="text"
                    placeholder="جستجوی نام پزشک"
                    value={searchValue}
                    onChange={(e) => {
                      setSearchValue(e.target.value);
                    }}
                  />
                </div>
              </div>
            </div>
          </div>
          {loading && (
            <span
              className="spinner-border spinner-border ms-1"
              role="status"
              aria-hidden="true"
            />
          )}

          {doctors && (
            <div className="tw-grid tw-grid-cols-1 md:tw-grid-cols-2 tw-gap-3 tw-w-full *:tw-w-full">
              {
                doctors.map((doctor, index) => (
                  <div key={index}>
                    <DoctorCard doctor={doctor} />
                  </div>
                ))
              }
              <nav aria-label="Page navigation example" className="tw-max-w-full tw-overflow-x-auto">
                <ul className="pagination">
                  {currentPage !== 1 && (
                    <li className="page-item">
                      <a
                        className="page-link"
                        disabled
                        href="#"
                        aria-label="Previous"
                        onClick={() => {
                          setCurrentPage(currentPage - 1);
                          scrollToTop();
                        }}
                      >
                        <span aria-hidden="true">&laquo;</span>
                      </a>
                    </li>
                  )}
                  {paginationElem}
                  {pageCount != currentPage && (
                    <li className="page-item">
                      <a
                        className="page-link"
                        disabled
                        href="#"
                        aria-label="Next"
                        onClick={() => {
                          setCurrentPage(currentPage + 1);
                          scrollToTop();
                        }}
                      >
                        <span aria-hidden="true">&raquo;</span>
                      </a>
                    </li>
                  )}
                </ul>
              </nav>
            </div>
          )}
        </div>
      </div>
      {/* Modals */}
      {/* select Specialty modal */}
      <div
        className="modal fade"
        id="specialty-modal"
        tabIndex="-1"
        aria-labelledby="specialty-modal-label"
        aria-hidden="true"
        onClick={() => {
          // Your custom logic when the modal is closed
          setSpecialtySearch("");
        }}
      >
        <div className="modal-dialog modal-dialog-scrollable">
          <div className="modal-content">
            <div className="modal-header border-bottom mx-0 py-2 color-bootstrap-gray-800">
              <ArrowRightAltIcon
                width={24}
                height={24}
                type="button"
                data-bs-dismiss="modal"
                aria-label="Close"
              />
              <input
                type="text"
                className="form-control border-0 shadow-none w-100"
                id="city-search-input"
                placeholder="جستجوی تخصص ..."
                value={specialtySearch}
                onChange={(e) => setSpecialtySearch(e.target.value)}
              />
            </div>
            <div className="modal-body">
              {/* Specialty Dropdown */}
              <div className="d-flex flex-column align-items-start">
                {specialties &&
                  specialties
                    .filter((specialty) =>
                      specialty.title.includes(specialtySearch.trim())
                    )
                    .map((specialty) => (
                      <button
                        className="btn btn-light w-100 d-flex align-items-start my-2"
                        data-bs-toggle="modal"
                        data-bs-target="#education-modal"
                        key={specialty.id}
                        value={specialty.id}
                        onClick={() => {
                          setSelectedSpecialtyId(specialty.id);
                          setSelectedSpecialtyTitle(specialty.title);
                        }}
                      >
                        {specialty.title}
                      </button>
                    ))}
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* select Education modal */}
      <div
        className="modal fade"
        id="education-modal"
        tabIndex="-1"
        aria-labelledby="education-modal-label"
        aria-hidden="true"
        onClick={() => {
          // Your custom logic when the modal is closed
          setEducationSearch("");
        }}
      >
        <div className="modal-dialog modal-dialog-scrollable">
          <div className="modal-content">
            <div className="modal-header border-bottom mx-0 py-2 color-bootstrap-gray-800">
              <ArrowRightAltIcon
                width={24}
                height={24}
                type="button"
                data-bs-dismiss="modal"
                aria-label="Close"
              />
              <input
                type="text"
                className="form-control border-0 shadow-none w-100"
                id="city-search-input"
                placeholder="جستجوی تحصیلات ..."
                value={educationSearch}
                onChange={(e) => setEducationSearch(e.target.value)}
              />
            </div>
            <div className="modal-body">
              {/* Educations Dropdown */}
              <div className="d-flex flex-column align-items-start">
                {educations &&
                  educations
                    .filter((education) =>
                      education.title.includes(educationSearch.trim())
                    )
                    .map((education) => (
                      <button
                        className="btn btn-light w-100 d-flex align-items-start my-2"
                        data-bs-dismiss="modal"
                        key={education.id}
                        value={education.id}
                        onClick={() => {
                          setSelectedEducationId(education.id);
                          setSelectedEducationTitle(education.title);
                          if (selectedSpecialtyId) {
                            setAddtolist(true);
                          }
                        }}
                      >
                        {education.title}
                      </button>
                    ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DoctorStore;
